/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Restore_SuccessInputs */



/**
* | output |
* | --- |
* | "Project restored. Teammates will get this version on their next sync." |
*
* @param {Snapshot_History_Restore_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_restore_success = /** @type {((inputs?: Snapshot_History_Restore_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Restore_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
	return /** @type {LocalizedString} */ ("Project restored. Teammates will get this version on their next sync.")
});